module.exports = __webpack_public_path__ + "img/zizhi11.d7ecede7.jpg";